import { useEffect, useState } from "react";
import "../../App.css";
import "./PublicCancelamentoForm.css";

import logo from "../../assets/img/logo-header.png";
import cancelamentoIcon from "../../assets/icons/desmarcar.png";

import CadastrosInternosService from "../../services/CadastrosInternosService";
import cancelarAgendamentoPublicDTO from "../../types/AgendamentoCancelamentoPublicDTO";
import AgendamentosService from "../../services/AgendamentosService";
import CancelamentosService from "../../services/CancelamentosService";

export default function PublicCancelamentoForm({ onClose, onSubmit, onSuccess }) {
  const [form, setForm] = useState({
    idAgendamento: "",
    idCadastro: "",
    nome: "",
    data: "",
    horario: "",
    motivo: ""
  });

  const [historico, setHistorico] = useState([]);
  const [agendamentoSelecionado, setAgendamentoSelecionado] = useState(null);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const idCadastro = localStorage.getItem("UserId");
  

  // ==========================
  // Carregar histórico e dados do usuário
  // ==========================
  useEffect(() => {
    async function carregarDados() {
      if (!idCadastro) return;

      try {
        const cliente = await CadastrosInternosService.getById(idCadastro);
        setForm(prev => ({
          ...prev,
          idCadastro: Number(idCadastro),
          nome: cliente.NOME
        }));

        const hist = await AgendamentosService.getAgendamentosAtivos(idCadastro);
        setHistorico(hist);
      } catch (error) {
        console.error("Erro ao carregar dados:", error);
      }
    }

    carregarDados();
  }, [idCadastro]);

  // ==========================
  // Selecionar agendamento
  // ==========================
  function handleSelectAgendamento(e) {
    const id = Number(e.target.value);
    if (!id) {
      setAgendamentoSelecionado(null);
      setForm(prev => ({ ...prev, idAgendamento: "", data: "", horario: "" }));
      return;
    }

    const ag = historico.find(a => a.IDAGENDAMENTO === id);
    setAgendamentoSelecionado(ag);

    if (ag) {
      setForm(prev => ({
        ...prev,
        idAgendamento: ag.IDAGENDAMENTO,
        data: ag.DATA,
        horario: ag.HORARIO,
        nome: ag.NOME ?? prev.NOME
      }));
    }
  }

  // ==========================
  // Handle changes
  // ==========================
  function handleChange(e) {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  }

  function validar() {
    const e = {};
    if (!form.idAgendamento) e.agendamento = "Selecione um agendamento";
    if (!form.motivo) e.motivo = "Informe o motivo";
    return e;
  }

  async function handleSubmit(e) {
    e.preventDefault();
    const v = validar();
    setErrors(v);
    if (Object.keys(v).length) return;

    setLoading(true);
    try {

      const ag = agendamentoSelecionado;

      const payload_cancelamento = cancelarAgendamentoPublicDTO({
        IDAGENDAMENTO: ag.IDAGENDAMENTO,
        IDCADASTRO: form.idCadastro,
        DATA: ag.DATA,
        IDHORARIO: Number(ag.IDHORARIO),
        MOTIVO: form.motivo
      });

      if (onSubmit) {
        await onSubmit({
          payload: payload_cancelamento
        });
      }

    } catch (error) {
      console.error("Erro ao cancelar agendamento:", error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="Cancelamento-form-container">
      <div className="Cancelamento-form-Fechar" onClick={onClose}> X </div>

      <img src={logo} alt="Logo" className="Cancelamento-form-logo" />

      <div className="Cancelamento-form-title">
        <img src={cancelamentoIcon} alt="" className="icon" />
        Cancelar Agendamento
      </div>
      <div className="Cancelamento-form-linha" />

      <form onSubmit={handleSubmit}>
        <div className='Cancelamento-form-alinhamento'>
          <label>Agendamento</label>
          <select
            value={form.idAgendamento}
            onChange={handleSelectAgendamento}
          >
            
            <option value="">Selecione um agendamento</option>
            {historico.map(ag => (
              <option key={ag.IDAGENDAMENTO} value={ag.IDAGENDAMENTO}>
                {ag.DATA} - {ag.HORARIO.slice(0,5)} - {ag.DESCRICAO}
              </option>
            ))}
          </select>
          {errors.agendamento && <span className="erro">{errors.agendamento}</span>}
        </div>

        <div className='Cancelamento-form-alinhamento'>
          <label>Nome</label>
          <input value={form.nome} disabled />
        </div>

        <div className='Cancelamento-form-alinhamento'>
          <label>Data</label>
          <input type="text" value={form.data} disabled />
        </div>

        <div className='Cancelamento-form-alinhamento'>
          <label>Horário</label>
          <input type="text" value={form.horario} disabled />
        </div>

        <div className='Cancelamento-form-alinhamento'>
          <label>Motivo do cancelamento *</label>
          <textarea
            name="motivo"
            value={form.motivo}
            onChange={handleChange}
          />
          {errors.motivo && <span className="erro">{errors.motivo}</span>}
        </div>

        <div className="Cancelamento-form-alinhamento-button">
          <button type="submit" disabled={loading} className="Cancelamento-form-button">
            {loading ? "Cancelando..." : "Cancelar"}
          </button>

          <button type="button" className="Cancelamento-form-button" onClick={onClose}>
            Voltar
          </button>
        </div>
      </form>
    </div>
  );
}
